import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { MechanicValidatorLargestArmy, MechanicValidatorDevelopmentCard } from '@colonist/game-mechanic-validators';
import { ArrayUtils } from '../../../../../shared/utils/ArrayUtils.ts';
import { CardEnum } from '@colonist/game-states';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIGameLargestArmyController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.PlayerControllerStateUpdated:
                this.updateLargestArmyStatus(data);
                break;
            default:
                break;
        }
    }
    updateLargestArmyStatus(animate) {
        for (const player of this.uiGameManager.gameState.players){
            if (!this.largestArmyValidator.getLargestArmyPlayerState(player.color).hasLargestArmy) continue;
            if (player.color == this.lastPlayerToHoldLargestArmy) continue;
            this.playerAchievedLargestArmy(player, animate);
        }
    }
    playerAchievedLargestArmy(playerState, animate) {
        var _this_developmentCardsValidator;
        var _this_developmentCardsValidator_getDevelopmentCardsPlayerState_developmentCardsUsed;
        const developmentCardsUsed = (_this_developmentCardsValidator_getDevelopmentCardsPlayerState_developmentCardsUsed = (_this_developmentCardsValidator = this.developmentCardsValidator) === null || _this_developmentCardsValidator === void 0 ? void 0 : _this_developmentCardsValidator.getDevelopmentCardsPlayerState(playerState.color).developmentCardsUsed) !== null && _this_developmentCardsValidator_getDevelopmentCardsPlayerState_developmentCardsUsed !== void 0 ? _this_developmentCardsValidator_getDevelopmentCardsPlayerState_developmentCardsUsed : [];
        const knightDevelopmentCardsUsedCount = ArrayUtils.countOccurenceOfValueInArray(developmentCardsUsed, CardEnum.Knight);
        const achievement = {
            achievementOwnerNew: playerState.color,
            achievementOwnerPrevious: this.lastPlayerToHoldLargestArmy,
            achievementType: 'LargestArmy',
            achievementScore: knightDevelopmentCardsUsedCount
        };
        this.lastPlayerToHoldLargestArmy = playerState.color;
        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement);
    }
    constructor(uiGameManager, largestArmyState, developmentCardsState){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.largestArmyValidator = new MechanicValidatorLargestArmy(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, largestArmyState);
        this.developmentCardsValidator = developmentCardsState ? new MechanicValidatorDevelopmentCard(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, developmentCardsState) : undefined;
        this.lastPlayerToHoldLargestArmy = this.largestArmyValidator.getPlayerWithLargestArmy();
    }
}
